/** The web app's version, baked in at build time from package.json (D88). */
declare const __KEYSTONE_VERSION__: string;

export const VERSION: string = typeof __KEYSTONE_VERSION__ === "string" ? __KEYSTONE_VERSION__ : "dev";

/** True when the server is on a different build from this screen — an old app shell cached on a phone. */
export function outOfStep(serverVersion: string | undefined | null): boolean {
  return Boolean(serverVersion) && serverVersion !== VERSION;
}
